module.exports = __webpack_public_path__ + "static/media/bg_04.522af992.png";